import { Injectable } from '@angular/core';
import { CertificationRequest, CertificationRequestStatus, CertificationType } from '@eemo/api-client';

@Injectable({ providedIn: 'root' })
export class CertificationHelper {
  constructor() {}

  getCertificationsRequestStatus(): string[] {
    return Object.values(CertificationRequestStatus);
  }

  getCertificationsRequestStatusName(status: CertificationRequestStatus): string {
    switch (status) {
      case 'OPEN':
        return 'Demande enregistrée';
      case 'IN_PROGRESS':
        return 'En cours de traitement';
      case 'REFUSED':
        return 'Refusée';
      case 'VALIDATED':
        return 'Validée';
      default:
        return 'Status inconnu';
    }
  }

  getCertificationTypeName(type: CertificationType): string {
    switch (type) {
      case 'OWNER':
        return 'Propriétaire';
      case 'PROFESSIONAL':
        return 'Professionnelle';
      case 'INHERITED':
        return 'Héritée';
      default:
        return 'Aucune';
    }
  }

  static isOnGoingCertificationRequest(request: CertificationRequest): boolean {
    return request && request.status !== CertificationRequestStatus.VALIDATED;
  }
}
